import styled from "@emotion/styled"
import { PAccordion, PHeading } from "@porsche-design-system/components-react"
import { colorContrastLower, spacingStaticMd, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { PropsWithChildren } from "react"
import { FormattedMessage } from "react-intl"
import type { MessageDescriptor } from "react-intl"
import { shouldForwardProp } from "src/common/shouldForwardProp"
import { NewBadge } from "../badge/NewBadge"
import { SkeletonText } from "./SkeletonText"

interface SkeletonAccordionProps extends PropsWithChildren {
	heading?: MessageDescriptor
	isNew?: boolean
	open?: boolean
	withBorder?: boolean
}

export const SkeletonAccordion = ({ children, heading, isNew, open, withBorder }: SkeletonAccordionProps) => (
	<BorderedDiv {...(heading && { as: PAccordion, open })} $withBorder={withBorder}>
		{heading ? (
			<>
				<PHeading size="sm" slot="summary">
					<FormattedMessage {...heading} />
					{isNew && <StyledNewBadge compact />}
				</PHeading>
				{children && <Wrapper>{children}</Wrapper>}
			</>
		) : (
			<SkeletonText $width="150px" />
		)}
	</BorderedDiv>
)

// align paddings with pds
// https://github.com/porsche-design-system/porsche-design-system/blob/main/packages/components/src/components/accordion/accordion-styles.ts#L85
const BorderedDiv = styled("div", { shouldForwardProp })<{ $withBorder?: boolean }>`
	${({ $withBorder }) =>
		$withBorder
			? `
		&:not(:first-child) {
			padding-top: ${spacingStaticMd};
			border-top: 1px solid ${colorContrastLower};
		}
		&:not(:last-child) {
			padding-bottom: ${spacingStaticMd};
		}
			`
			: `
		&:not(:first-child) {
			margin-top: 2px;
		}
		`}
`

const Wrapper = styled.div`
	margin-top: ${spacingStaticMd};
`

const StyledNewBadge = styled(NewBadge)`
	margin-inline-start: ${spacingStaticSm};
`
